import type { ICustomControlProcedureDiagnosticReportReadProps } from '@frontend/components/pages/customControls/interfaces';
import { OcrkV1RequestReadOork } from '../../OCRK/v1/OcrkV1RequestReadOork';
import { OorkV1DiagnosticReportRead } from './OorkV1DiagnosticReportRead';
import { OorkV1ProcedureRead } from './OorkV1ProcedureRead';

export function OorkV1ProcedureDiagnosticReportRead(props: ICustomControlProcedureDiagnosticReportReadProps) {
    return (
        <>
            <OorkV1ProcedureRead {...props} />
            <OorkV1DiagnosticReportRead {...props} />
            <OcrkV1RequestReadOork {...props} />
        </>
    );
}
